import API from "./baseApi";

const create = (payload) => {
  return API.post("/communication/config", payload);
};

const findAll = (payload) => {
  return API.post("/communication/config/list", payload);
};

const findOne = (id, payload) => {
  return API.get(`/communication/config/${id}`, payload);
};

const update = (id, payload) => {
  return API.put(`/communication/config/${id}`, payload);
};

const remove = (id) => {
  return API.delete(`/communication/config/${id}`);
};

export default {
  create,
  findAll,
  findOne,
  update,
  remove,
};
